<!--
 * @Author: your name
 * @Date: 2021-05-28 14:07:58
 * @LastEditTime: 2021-05-28 15:24:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fpv5_h5\src\pages\mcmsmanager\channel\user\list.vue
-->
<template>
  <div>
    <a-card size="small" title="用户管理">
        <div slot="extra">
        <a-button  type="primary" @click="handleNew" style="margin-right:20px;">新增</a-button>
        <a-button type="link" style="margin-right:20px" @click="handleDownload">下载模板</a-button>

         <a-tooltip placement="top">
                <template slot="title">
                    <span>servicekey已存在的记录会被忽略</span>
                </template>
                <a-upload
                    name="file"
                    :multiple="true"
                    action="https://032001.zhonglunnet.com"
                    :headers="headers"
                    :data="handleImportFile"
                    @change="handleChange"
                >
                    <a-button type="primary"  :loading="isImporting">
                        <a-icon type="upload"/>
                        导入用户
                    </a-button>
                </a-upload>
         </a-tooltip>
        </div>
       
        <searchE @handleSearch="handleSubmit"></searchE>

        
        <tableE ref="userTableID"></tableE>

    </a-card>

     
  </div>
</template>
<script>

import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            isImporting: false,
            headers: {
                authorization: 'authorization-text',
            },
        };
    },
    methods: {
        handleDownload(){
            window.open("https://032001.zhonglunnet.com/fp-web/%E5%AF%BC%E5%85%A5%E7%94%A8%E6%88%B7%E6%95%B0%E6%8D%AE(%E4%B8%80%E6%AC%A1%E6%80%A7%E5%AF%BC%E5%85%A5%E6%95%B0%E6%8D%AE%E4%B8%8D%E8%A6%81%E8%B6%85%E8%BF%872000).xls");
        },
        handleSubmit(searchP){
            this.$refs.userTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "add_user",
                query: {id:''}
            });
        },

        handleImportFile(file) {
            // let that = this;
            let result = this.D.syncSelect({
                type: 'servicekey/importConfig',
                params: {}
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false;
            }
            const data = result.data;
            const {
                dir,
                policy,
                accessid,
                callback,
                signature
            } = data;
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature
            };
            const objName = dir + this.getUniqueCode() + this.getSuffix(file.name);
            file.objName = objName;
            return {
                ...token,
                key: objName
            }

        },
        
        getUniqueCode() {
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            return s.join("");
        },
        getSuffix(filename) {
            const pos = filename.lastIndexOf('.');
            let suffix = '';
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },
        
        //上传文件结果处理
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                this.saveImportRecord(info.file.objName, info.file.originFileObj.name);
                this.message.success(`${info.file.name} file uploaded successfully`);

            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`);
            }
        },

        saveImportRecord(fileUrl, filename) {
            this.isImporting = true;
            this.$store
                .dispatch({
                    type: 'servicekey/saveImportService',
                    params: {
                        importbusinesstype: 'importMcmsUserList',
                        shopcode: '125806668',
                        loginuserbranchcode: '1001',
                        sourcefile: fileUrl,
                        filename: filename,
                        syncstatus: 1,
                        updownstatus: 1,
                    }
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.importId = res.data.data
                        this.checkImportStatue();

                        //刷新页面
                        this.$router.push({
                            path: this.action,
                            query: ''
                        });

                    } else {
                        this.isImporting = false;
                        this.message.error('导入失败')
                    }

                }).catch((e) => {
                    this.isImporting = false;
                    this.message.error('导入失败' + e.message)
                });
        },
        checkImportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isImporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkImportStatue',
                        params: {id: that.importId}
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.importstatus == 1) {
                                //导入成功
                                that.isImporting = false
                                console.log(res)

                            } else if (res.data.data.importstatus == 2) {
                                that.isImporting = false
                                that.message.error(res.data.data.errormsg)
                            } else {
                                that.checkImportStatue()
                            }
                        } else {
                            that.checkImportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            }, 2000);

        },
    },
    components:{
        searchE,
        tableE
    },
    mounted(){


    }
};
</script>
<style scoped>

</style>
